import type { Guard } from './index';
import { useAuthStore } from '@/store/auth.store';
import { useConfigStore } from '@/store/config.store';

async function fetchSettingsIfNeeded(): Promise<void> {
  const configStore = useConfigStore();
  const settings = configStore.getSettings;
  if (!Object.keys(settings).length) {
    await configStore.actionFetchSettings();
  }
}

export const gamification: Guard = async (to, from, next) => {
  const authStore = useAuthStore();
  const configStore = useConfigStore();
  await fetchSettingsIfNeeded();
  const isGamificationActive = configStore.getIsGamificationActive;

  if (authStore.isAdmin() || isGamificationActive) {
    return next();
  }
  return next({ name: 'Home' });
};

export const gamificationConfig: Guard = async (to, from, next) => {
  const authStore = useAuthStore();
  await fetchSettingsIfNeeded();

  if (authStore.isAdmin()) {
    return next();
  }
  return next({ name: 'gamification' });
};

export const gamificationRanking: Guard = async (to, from, next) => {
  const configStore = useConfigStore();
  await fetchSettingsIfNeeded();
  const isGamificationActive = configStore.getIsGamificationActive;

  if (isGamificationActive) {
    return next();
  }
  return next({ name: 'gamification' });
};
